

































































import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import TotalsChart from "../components/TotalsChart.vue";
import {
  MonthTotalDataItem,
  TopDataItem,
  DistroDataSet,
  CountryTotalDataItem,
  NameValuePair,
  Filter
} from "@/classes/DistroDataSet";
import TopWidget from "@/components/TopWidget.vue";
import TotalsMap from "@/components/TotalsMap.vue";
import TotalWidget from "@/components/TotalWidget.vue";

@Component({
  components: {
    "totals-chart": TotalsChart,
    "totals-map": TotalsMap,
    "top-widget": TopWidget,
    "total-widget": TotalWidget
  }
})
export default class Release extends Vue {
  @Prop() public dataSet!: DistroDataSet;
  @Prop() public datesFilter!: Date[];

  monthlyTotals: MonthTotalDataItem[] = [];
  countryTotals: CountryTotalDataItem[] = [];
  topCountriesByRevenue: TopDataItem[] = [];
  topStoresByRevenue: TopDataItem[] = [];
  totalEarnings = 0;

  release: NameValuePair = { value: "--not set--", name: "(none)" };
  allReleases: NameValuePair[] = [];

  mounted() {
    this.setData();
  }

  @Watch("datesFilter")
  @Watch("release")
  setData() {
    const [fromDate, toDate] = this.$props.datesFilter;

    this.allReleases = this.$props.dataSet.getUniqueNameValues(
      "isrc",
      "title",
      {
        fromDate: fromDate,
        toDate: toDate
      }
    );

    let releaseLookup: NameValuePair | string | undefined = this.release;
    if (this.release === undefined || this.release.value === "--not set--") {
      releaseLookup = this.allReleases.find(
        r => r.value === this.$route.params.id
      );
    } else if (typeof this.release === "string") {
      releaseLookup = this.allReleases.find(
        r => r.value === this.release.toString()
      );
    }
    this.release = (releaseLookup as NameValuePair) ||
      this.allReleases[0] || { value: "--not set--", name: "(none)" };

    const filter: Filter = {
      fromDate: fromDate,
      toDate: toDate,
      isrc: this.release.value
    };
    this.monthlyTotals = this.$props.dataSet.getMonthTotals(filter);
    this.countryTotals = this.$props.dataSet.getCountryTotals(filter);
    this.topCountriesByRevenue = this.$props.dataSet.getTopCountriesByRevenue(
      filter
    );
    this.topStoresByRevenue = this.$props.dataSet.getTopStoresByRevenue(filter);
    this.totalEarnings = this.$props.dataSet.getTotalEarnings(filter);
  }
}
